import { useMemo } from 'react'
import { useRouteMatch } from '../../../../../../node_modules/react-router-dom/cjs/react-router-dom.min'
import { FolderMenu } from '../common/menu/node-actions'
import { GridNode } from '../common/shared/grid-item'
import { IconCategory } from '../../../../../shared/icon/icon'

// `section` is the grid's (FOLDER_SECTION): what a folder can hold differs.
export const NodeCategoryGridItem = ({ node, dataContext, section }) => {
  const { url } = useRouteMatch()

  const to = useMemo(() => `${url}/node/${node.id}`, [url, node])

  const FooterMenu = () => <FolderMenu place="card" url={`${url}/node/${node.id}`} nodeID={node.id} section={section} />

  return <GridNode Icon={IconCategory} FooterMenu={FooterMenu} node={node} to={to} dataContext={dataContext} />
}
